module.exports = __webpack_public_path__ + "static/media/funnykim.93dd6899.jpg";